
    import './styles.scoped.css';
    export default {
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_lpshu_lmq7o_97",
  "trigger": "awsui_trigger_lpshu_lmq7o_97",
  "selected": "awsui_selected_lpshu_lmq7o_186",
  "badge": "awsui_badge_lpshu_lmq7o_206",
  "trigger-wrapper": "awsui_trigger-wrapper_lpshu_lmq7o_210",
  "dot": "awsui_dot_lpshu_lmq7o_218"
};
  